import React from 'react';
import { observer } from 'mobx-react';

import { Card } from 'core/components/card';
import alertIcon from 'core/assets/svg/info-dark-green.svg';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';

import useStyles from './agency-help-modal.styles';

const AgencyHelpModal = observer(({ setOpenAgencyHelpModal, username }) => {
  const classes = useStyles();

  const goBack = () => {
    setOpenAgencyHelpModal(false);
  };

  return (
    <BaseDialog onClose={goBack} open fullWidth size="sm">
      <Label className={classes.title} type="titleSecondary">
        Agency support contact number
      </Label>
      <a href="tel:8554385411" className={classes.number}>
        <Label type="green15BigBold">(855) 438-5411</Label>
      </a>
      <Label className={classes.hours} type="modalBody">
        Mon-Fri, 9am-7pm EST
      </Label>
      <Label className={classes.body} type="modalBody">
        For the fastest service,{' '}
        <span className={classes.bold}>please be logged into Staff and have your username ready: {username}.</span> This
        is not your producer code. You can find your other personal and agency information in the top right corner of
        the Agency Portal tab.
      </Label>

      <Card className={classes.cardContainer}>
        <img src={alertIcon} className={classes.icon} alt="Notification Icon" />
        <Label className={classes.cardBody} type="smallDarkGreenBold">
          Did you know you can find helpful how-to videos in the training section of our Agency Portal? You can also
          schedule time for you or your agency team to meet with our training team.
        </Label>
      </Card>
    </BaseDialog>
  );
});

export default AgencyHelpModal;
